import React from "react";
import PMService from "../../services/pmService";
import Search from "../search/Search";
import { Layout } from "antd";
import "antd/dist/antd.css";
import "./header.css";

const { Header } = Layout;

export default class Head extends React.Component {
  pmService = new PMService();

  state = {
    inputValue: "",
  };

  handleChange = e => {
    e.preventDefault();
    this.setState({ inputValue: e.currentTarget.value });
  };
  handleSubmit = () => {
    this.props.inputValue(this.state.inputValue);
    this.setState({ inputValue: "" });
  };

  render() {
    const { logout, login, user } = this.props;

    return (
      <Header
        className="header"
        style={{
          backgroundColor: "#ffdd03",
          height: "auto",
        }}
      >
        <div
          className="container-menu"
          style={{
            lineHeight: "62px",
            display: "flex",
            backgroundColor: "#ffdd03",
          }}
        >
          <div className="name" key="1">
            <b style={{ color: "#000000" }}>PubMedSearch</b>
          </div>
          <Search
            example={this.props.example || null}
            user={user}
            logout={logout}
            login={login}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            inputValue={this.state.inputValue}
          />
        </div>
      </Header>
    );
  }
}
